'use client';
import React from 'react';

const tourLinks = [
  { label: 'Private Morocco Tours', href: '#services' },
  { label: 'Jewish Heritage Tours', href: '#jewish-heritage' },
  { label: 'Casablanca Tours', href: '#services' },
  { label: 'Day Trips', href: '#services' },
  { label: 'Luxury Chauffeur', href: '#services' },
  { label: 'Airport Transfers', href: '#services' },
  { label: 'Cruise Excursions', href: '#services' },
  { label: 'Custom Tours', href: '#services' },
];

const destinationLinks = [
  'Casablanca', 'Marrakech', 'Fes', 'Rabat',
  'Essaouira', 'Tangier', 'Chefchaouen', 'Sahara Desert',
  'Atlas Mountains', 'Meknes', 'Volubilis', 'Jewish Mellahs',
];

const infoLinks = [
  { label: 'About David', href: '#about' },
  { label: 'Jewish Heritage', href: '#jewish-heritage' },
  { label: 'Why Choose Us', href: '#why-us' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Blog', href: '#blog' },
  { label: 'Contact', href: '#contact' },
];

const socialLinks = [
  {
    label: 'WhatsApp',
    href: 'https://wa.me/212668702424',
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    ),
  },
  {
    label: 'Facebook',
    href: '#',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    label: 'Instagram',
    href: '#',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    label: 'TripAdvisor',
    href: '#',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12.006 4.295c-2.67 0-5.338.784-7.645 2.353H0l1.963 2.135a5.997 5.997 0 00-.08 8.537 6.01 6.01 0 008.516.073L12 19.705l1.6-2.312a6.01 6.01 0 008.517-.073 5.997 5.997 0 00-.08-8.537L24 6.648h-4.349c-2.307-1.57-4.976-2.353-7.645-2.353zM7.951 16.006a3.954 3.954 0 01-3.954-3.954 3.954 3.954 0 013.954-3.954 3.954 3.954 0 013.954 3.954 3.954 3.954 0 01-3.954 3.954zm8.098 0a3.954 3.954 0 01-3.954-3.954 3.954 3.954 0 013.954-3.954 3.954 3.954 0 013.954 3.954 3.954 3.954 0 01-3.954 3.954zM7.95 9.765a2.287 2.287 0 100 4.574 2.287 2.287 0 000-4.574zm8.1 0a2.287 2.287 0 100 4.574 2.287 2.287 0 000-4.574z" />
      </svg>
    ),
  },
];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const currentYear = 2024;

  return (
    <footer className="bg-navy-dark text-white">
      {/* Top CTA Bar */}
      <div className="bg-gold py-6">
        <div className="container-luxury">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div>
              <h3 className="font-serif text-xl font-bold text-navy-dark">
                Ready to Discover Morocco?
              </h3>
              <p className="font-sans text-sm text-navy/80">
                Contact David today and start planning your perfect journey.
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <a
                href="https://wa.me/212668702424?text=Hello%20David%2C%20I%20am%20interested%20in%20booking%20a%20tour."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-navy text-white font-sans text-xs font-bold uppercase tracking-wider hover:bg-navy-light transition-colors duration-200"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                WhatsApp David
              </a>
              <button
                onClick={() => handleNavClick('#contact')}
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-white text-navy-dark font-sans text-xs font-bold uppercase tracking-wider hover:bg-cream transition-colors duration-200"
              >
                Book a Tour
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="py-16">
        <div className="container-luxury">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
            {/* Brand Column */}
            <div className="lg:col-span-2">
              <div className="mb-4">
                <span className="font-serif text-2xl font-bold">
                  Morocco<span className="text-gold">Jewish</span>Tours
                </span>
                <div className="font-sans text-xs text-gold/80 uppercase tracking-widest mt-1">
                  Private Luxury Experiences
                </div>
              </div>
              <div className="w-12 h-0.5 bg-gold mb-5" />
              <p className="font-sans text-sm text-white/70 leading-relaxed mb-6">
                Licensed professional tour guide David offers private luxury tours, Jewish heritage
                journeys, and tailor-made travel experiences across Morocco. Serving travelers from
                the USA, Canada, UK, Israel, France, and Australia.
              </p>

              {/* Contact Info */}
              <div className="space-y-3 mb-6">
                <a href="tel:+212668702424" className="flex items-center gap-3 font-sans text-sm text-white/70 hover:text-gold transition-colors">
                  <svg className="w-4 h-4 text-gold flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  +212 668 702 424
                </a>
                <a href="mailto:dbdahantours@gmail.com" className="flex items-center gap-3 font-sans text-sm text-white/70 hover:text-gold transition-colors">
                  <svg className="w-4 h-4 text-gold flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  dbdahantours@gmail.com
                </a>
                <div className="flex items-center gap-3 font-sans text-sm text-white/70">
                  <svg className="w-4 h-4 text-gold flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Casablanca, Morocco
                </div>
              </div>

              {/* Flags */}
              <div className="flex flex-wrap gap-2 mb-6">
                {['🇺🇸', '🇨🇦', '🇬🇧', '🇮🇱', '🇫🇷', '🇦🇺'].map((flag) => (
                  <span key={flag} className="text-xl">{flag}</span>
                ))}
              </div>

              {/* Social */}
              <div className="flex gap-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    className="w-9 h-9 bg-white/10 hover:bg-gold hover:text-navy-dark text-white flex items-center justify-center transition-all duration-300"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Tours */}
            <div>
              <h4 className="font-sans text-xs font-bold uppercase tracking-widest text-gold mb-5">
                Our Tours
              </h4>
              <ul className="space-y-2.5">
                {tourLinks.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => handleNavClick(link.href)}
                      className="font-sans text-sm text-white/60 hover:text-gold transition-colors duration-200 flex items-center gap-2"
                    >
                      <span className="w-1 h-1 bg-gold/60 flex-shrink-0" />
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Destinations */}
            <div>
              <h4 className="font-sans text-xs font-bold uppercase tracking-widest text-gold mb-5">
                Destinations
              </h4>
              <ul className="space-y-2.5">
                {destinationLinks.map((dest) => (
                  <li key={dest}>
                    <button
                      onClick={() => handleNavClick('#destinations')}
                      className="font-sans text-sm text-white/60 hover:text-gold transition-colors duration-200 flex items-center gap-2"
                    >
                      <span className="w-1 h-1 bg-gold/60 flex-shrink-0" />
                      {dest}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Info */}
            <div>
              <h4 className="font-sans text-xs font-bold uppercase tracking-widest text-gold mb-5">
                Information
              </h4>
              <ul className="space-y-2.5 mb-8">
                {infoLinks.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => handleNavClick(link.href)}
                      className="font-sans text-sm text-white/60 hover:text-gold transition-colors duration-200 flex items-center gap-2"
                    >
                      <span className="w-1 h-1 bg-gold/60 flex-shrink-0" />
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>

              {/* Trust Badges */}
              <div className="space-y-2">
                <div className="flex items-center gap-2 font-sans text-xs text-white/50">
                  <span className="text-gold">✓</span>
                  Ministry of Tourism Licensed
                </div>
                <div className="flex items-center gap-2 font-sans text-xs text-white/50">
                  <span className="text-gold">★</span>
                  5-Star Rated Service
                </div>
                <div className="flex items-center gap-2 font-sans text-xs text-white/50">
                  <span className="text-gold">🔒</span>
                  100% Private Tours
                </div>
                <div className="flex items-center gap-2 font-sans text-xs text-white/50">
                  <span className="text-gold">✡️</span>
                  Jewish Heritage Expert
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 py-6">
        <div className="container-luxury">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="font-sans text-xs text-white/50">
              &copy; {currentYear} MoroccoJewishTours. All rights reserved. Licensed Tour Guide — Morocco.
            </p>
            <div className="flex flex-wrap gap-6">
              {['Privacy Policy', 'Terms of Service', 'Sitemap'].map((link) => (
                <button
                  key={link}
                  className="font-sans text-xs text-white/50 hover:text-gold transition-colors duration-200"
                >
                  {link}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
